export default {
    path: '/Ali-pay',
    meta: {
        title: '',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/Ali-pay`),
}


// WEBPACK FOOTER //
// ./src/views/AliPay/router.js